<template>
  <div class="sidebar" style=" background-image: linear-gradient(180deg,#FDCA67,#FFB936,#EFBF62,#7F6534);"
       :data-active-color="activeColor">
    <div class="logo sidebar__logo" :style="{'background-image': 'url(' + require('@/assets/img/background-path.png') + ')'}">
      <a class="simple-text logo-mini" aria-label="sidebar mini logo" href="/">
          <div class="logo-img">
              <img :src="require('@/assets/img/drawable-xxxhdpi/tree-of-life-logo-wit.png')" alt="">
          </div>
      </a>
      <a class="simple-text logo-normal" href="/">
          TRAINERS APP
      </a>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <!-- <slot>

      </slot> -->
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link" v-show="link.permission === userType">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
      <div class="sidebar-map">
        <div class="sidebar-inner-map">
          <img :src="require('@/assets/img/map/drawable-xxxhdpi/Image 2.png')" width="100vw" alt="">
        </div>
      </div>
        <ul class="sidebar-footer">

          <li><img :src="require('@/assets/img/crown/drawable-xxxhdpi/crownlogo.png')" alt=""></li>
          <li><img :src="require('@/assets/img/black-logo/drawable-xxxhdpi/tol.png')" alt=""></li>
          <li><img :src="require('@/assets/img/botton-text/drawable-xxxhdpi/fff-black.png')" alt=""></li>

        </ul>

    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  export default {
    data() {
      return {
         user: localStorage.getItem("user"),
         userType:'',
      }
    },
    props: {
      title: {
        type: String,
        default: 'Vue PDP Pro',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: 'static/img/vue-logo.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync();
      this.authUser = JSON.parse(this.user);
      this.userType = this.authUser[0].roleName;
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style scoped>
.sidebar .logo.sidebar__logo{
    padding: 30px 0.7rem 35px;
}
.sidebar:after{
   background-image: linear-gradient(180deg,#FDCA67,#FFB936,#EFBF62) !important;
}
.simple-text.logo-normal{
  letter-spacing: 0.15rem;
}
.logo.sidebar__logo{
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.sidebar-footer{
  display: flex;
}
.sidebar-footer li{
  list-style: none;
}
.sidebar-map{
  text-align: center;
  padding: 5vw 0 3vw;
}
.sidebar-inner-map{
  display: inline-block;
}
.sidebar-inner-map img{
  width: 15vw;
}
.sidebar-footer li:nth-child(2){
  padding: 0 2rem;
}
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
